import { useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./Review.gql";

export const useGetReviews = (props = {}) => {
  const { product } = props;

  const { getReviewList, getReviewMetaData } = DEFAULT_OPERATIONS;
  const { data: ReviewData } = useQuery(getReviewList, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    variables: {
      sku: product.sku,
    },
    skip: !product.sku,
    context: { fetchOptions: { method: "GET" } },
  });

  const { data: reviewMetaData } = useQuery(getReviewMetaData, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    context: { fetchOptions: { method: "GET" } },
  });

  return {
    ReviewData,
    reviewMetaData,
  };
};
